const data = {
  currentIssueCover: '//www.fastcompany.com/magazine/latest-cover.jpg',
  magazineLink: 'https://www.fastcompany.com/magazine/',
  subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
  cosites: [
    {
      siteTitle: 'FastCoDesign',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488299643/fc/CO.DESIGN_BURGER_LOCKUP.svg',
      siteURL: '//www.fastcodesign.com'
    },
    {
      siteTitle: 'FastCoStudios',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488300562/fc/video_burger.svg',
      siteURL: '//www.fastcompany.com/videos'
    }
  ],
  social: {
    fastcompany: [
      {
        property: 'facebook',
        url: 'https://www.facebook.com/FastCompany/',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/fb-icon-cccccc-2x_anjwvt.svg',
        image_menu:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/fb-icon-777777-2xx_k6wkkl.svg'
      },
      {
        property: 'twitter',
        url: 'https://twitter.com/fastcompany',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/tw-icon-cccccc-2x_xgkf9v.svg',
        image_menu:
          'https://images.fastcompany.net/image/upload/v1540911627/fcweb/tw-icon-777777-2x_hgnmua.svg'
      },
      {
        property: 'instagram',
        url: 'https://www.instagram.com/fastcompany/',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/insta-icon-cccccc-2x_qsacmj.svg',
        image_menu:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/insta-icon-777777-2x_z8clum.svg'
      },
      {
        property: 'pocket',
        url: 'https://getpocket.com/explore/fastcompany.com',
        image:
          'https://images.fastcompany.net/image/upload/v1540911627/fcweb/pocket-icon-cccccc-2x_vary1a.svg',
        image_menu:
          'https://images.fastcompany.net/image/upload/v1540911627/fcweb/pocket-icon-777777-2x_d6c0dn.svg'
      },
      {
        property: 'linkedin',
        url: 'https://www.linkedin.com/company/fast-company',
        image:
          'https://images.fastcompany.net/image/upload/v1540911626/fcweb/linkedin-icon-cccccc-2x_ceogdj.svg',
        image_menu:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/linkedin-icon-777777-2x_oet1sg.svg'
      }
    ]
  },
  collections: [
    {
      title: 'collections',
      className: 'main-menu__collections',
      isOpen: false,
      sections: [
        {
          title: 'Recommender',
          url: 'https://www.fastcompany.com/section/the-recommender',
          deck:
            'The apps, books, movies, music, TV shows, and art are inspiring our some of the most creative people in business this month'
        },
        {
          title: 'Strong Female Lead',
          url: 'https://www.fastcompany.com/section/strong-female-lead',
          deck:
            'The struggles and triumphs of prominent women in leadership positions'
        },
        {
          title: 'Productivity',
          url: 'https://www.fastcompany.com/section/productivity',
          deck: 'Productivity tips and hacks'
        },
        {
          title: 'Platform Wars',
          url: 'https://www.fastcompany.com/section/platform-wars',
          deck:
            'The major tech ecosystems that battle for our attention and dollars'
        },
        {
          title: 'Tech Forecast',
          url: 'https://www.fastcompany.com/section/tech-forecast',
          deck: 'What’s next for hardware, software, and services'
        },
        {
          title: 'Most Innovative Companies',
          url: 'https://www.fastcompany.com/most-innovative-companies/2018',
          deck: 'Our annual guide to the businesses that matter the most'
        },
        {
          title: 'Most Creative People',
          url: 'https://www.fastcompany.com/most-creative-people/2018',
          deck:
            'Leaders who are shaping the future of business in creative ways'
        },
        {
          title: 'World Changing Ideas',
          url: 'https://www.fastcompany.com/section/world-changing-ideas',
          deck:
            'New workplaces, new food sources, new medicine--even an entirely new economic system'
        },
        {
          title: 'Innovation By Design',
          url: 'https://www.fastcompany.com/innovation-by-design/2018',
          deck: 'Celebrating the best ideas in business'
        },
        {
          title: 'FastCo.Works Studio',
          url: 'https://www.fastcompany.com/user/fastco-works',
          deck:
            "An award-winning team of journalists, designers, and videographers who tell brand stories through Fast Company's distinctive lens"
        }
      ]
    }
  ]
};

export default data;
